import { serviceRequest } from 'utils/http';
import { SiteEmployeeService, UpdateNotificationDto } from 'common/api';

export function updateShowNotification(requestBody: UpdateNotificationDto) {
  return serviceRequest(() =>
    SiteEmployeeService.siteEmployeeControllerUpdateNotification(
      requestBody.siteEmployeeId,
      requestBody
    )
  );
}
